import _Vue from 'vue'
import { PublicClientApplication } from '@azure/msal-browser'
import { AccountInfo, AuthenticationResult } from '@azure/msal-common'
import { AzureOptionsType } from '@/utilities/plugin/types/AzureOptionsType'
import { AuthPopupRedirectUrl } from '@/utilities/helper/AuthPopupRedirectUrl'

const authRedirectUrl = new AuthPopupRedirectUrl()

if (authRedirectUrl.isPopup(window) && authRedirectUrl.hasCode(location.href)) {
  throw new Error('Stop running script if url contains #code')
}

export default {
  install(Vue: typeof _Vue, options: AzureOptionsType) {
    const clientApplication = new PublicClientApplication({
      auth: {
        clientId: options.apiKey.clientId,
        authority: `https://login.microsoftonline.com/${options.apiKey.tenantId}`,
        redirectUri: options.uri,
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
    })

    Vue.$azure = Vue.prototype.$azure = {
      apiKey: options.apiKey,
      uri: options.uri,
      url: 'https://login.microsoftonline.com',

      init(): PublicClientApplication {
        return clientApplication
      },

      getAccount(): AccountInfo | undefined {
        const accounts = this.init().getAllAccounts()

        if (!accounts) {
          return undefined
        }

        return accounts.shift()
      },

      async refreshToken(): Promise<AuthenticationResult> {
        const account = this.getAccount()

        if (!account) {
          throw new Error('You should be logged in')
        }

        return await this.init().acquireTokenSilent({
          scopes: ['openid', 'profile'],
          account,
          forceRefresh: true,
        })
      },
    }
  },
}
